<!-- 个人中心 -->
<template>
  <div class="frame">
    <div class="wrap">
      <div class="left">
        <div class="in">
          <div class="link-map">
            <div class="title">功能导航</div>
            <div class="subs">
              <div
                :class="{ sub: true, active: $route.path == item.path }"
                v-for="item in map"
                :key="item.path"
              >
                <router-link :to="item.path">{{ item.name }}</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="label-title">
          <span>{{ $route.name }}</span>
        </div>
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      map: [
        { path: "/mine/profile", name: "个人中心" },
        { path: "/mine/info", name: "个人信息" },
        { path: "/mine/myApply", name: "报名记录" },
        { path: "/mine/myExam", name: "考试记录" },
        { path: "/mine/myCertificate", name: "我的证书" },
      ],
      breadcrumbs: [],
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
      },
      list: [],
      totalData: 0,
    };
  },
  created() {},
  methods: {
    navToDetail(item) {
      this.$router.push("/newDetail" + this.$route.path + "/" + item);
    },
  },
};
</script>

<style lang="scss" scoped>
.frame {
  background-color: #e9eaed;

  &::before,
  &::after {
    content: "";
    display: table;
  }
}
.wrap {
  display: flex;
  width: 1200px;
  margin: 20px auto;
  background-color: #fff;

  .left {
    width: 25%;
    padding: 20px;
    box-sizing: border-box;
    position: relative;

    .in {
      background-color: #fff;

      .title {
        color: #fff;
        background: $theme;
        font-weight: bold;
        padding: 7px 10px;
        margin-bottom: 10px;
      }
      .subs {
        .sub {
          border-bottom: 1px dashed #7d7d7d;
          margin: 2px 0 5px;
          line-height: 36px;
          font-size: 12px;
          position: relative;
          text-align: center;

          &:hover {
            background-color: #fef0f0;
            border-color: $theme;
            color: $theme;
            cursor: pointer;

            &::after {
              border-left-color: $theme;
            }
          }

          &::after {
            content: "";
            display: block;
            width: 0px;
            height: 0px;
            border: 5px solid transparent;
            border-left-color: #7e7e7e;
            position: absolute;
            left: 0;
            top: 13px;
          }

          a {
            width: 100%;
            height: 100%;
            display: block;
          }
        }
        .active {
          background-color: #fef0f0;
          border-color: $theme;
          color: $theme;
          cursor: pointer;

          &::after {
            border-left-color: $theme;
          }
        }
      }
    }
  }
  .right {
    width: 75%;
    min-height: 60vh;
    padding: 20px;
    box-sizing: border-box;

    .label-title {
      padding: 0 20px 0 70px;
      margin-bottom: 20px;
      position: relative;

      &::before {
        content: "";
        width: 100%;
        height: 1px;
        background: #ccc;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
      }

      span {
        padding: 5px 20px;
        border-radius: 18px;
        background: #a4a4a4;
        color: #fff;
        position: relative;
        z-index: 2;

        &::before,
        &::after {
          content: "";
          width: 7px;
          height: 7px;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          background: #ccc;
          border-radius: 50%;
        }
        &::before {
          left: -20px;
        }
        &::after {
          right: -20px;
        }
      }
    }

    .list {
      padding: 25px 0;

      .item {
        padding: 20px 10px;
        border-bottom: 1px solid #eeeeee;

        &:hover {
          background-color: #eee;
          cursor: pointer;
        }

        .title {
          font-size: 18px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .intro {
          padding-top: 8px;
          color: #8a8a8a;
          font-size: 14px;
        }
        .time {
          font-size: 12px;
          color: #999999;
          padding-top: 8px;
        }
      }
    }
  }
}
</style>
